import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class BusinessPartnerApi extends BaseApi {
  async getBusinessPartnerList(
    params: APIPaths["/admin-dash/business-partner/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/admin-dash/business-partner/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/admin-dash/business-partner/list", { params })).data;
  }
}
